import { appConfig } from '@common/config';
import { DETAIL_STATE } from '@constants/common';
import { isGemItemType } from '@constants/gemType';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { type IDetailIndexPorps, type IDetailItemDicInfo } from '@interface/IDetail';
import { itemInfoQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import { keepPreviousData } from '@tanstack/react-query';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { FolderBtn } from '../FolderBtn';
import { AdditionalEffects } from './SecAttributes/AdditionalEffects';
import { Description } from './SecAttributes/Description';
import { EnchantableItem } from './SecAttributes/EnchantableItem';
import { FixedOptions } from './SecAttributes/FixedOptions';
import { OptionsList } from './SecAttributes/OptionsList';
import { RandomOptions } from './SecAttributes/RandomOptions';
import { Randoms } from './SecAttributes/Randoms';

export const SecAttribute = ({ props }: { props: IDetailIndexPorps }) => {
    const { t } = useTranslation();
    const [isFolderOepn, setIsFolderOepn] = useState(props.detailNow !== 'noti');
    const setParams = useSetSearchParams();

    const { data: iteminfo } = useDataQuery<IDetailItemDicInfo>(
        itemInfoQueryKey,
        `/${appConfig.service}/v2.0/game/item/${props.detailId}`,
        { level: props.detailLevel },
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: props.detailNow === DETAIL_STATE.ITEM && !!props.detailId,
        }
    );

    if (!iteminfo?.name) return null;

    const handleEnchantedClick = () => {
        const sec = document.querySelector('.gameinfo-detail__section');
        sec && sec.scrollTo({ top: 0, behavior: 'smooth' });
        setParams({ detail: `item_${iteminfo?.enchanted.id}_${iteminfo?.enchanted.level}_0` });
    };

    return (
        <section className="attribute">
            <header>
                <h3>{t('common.iteminfo')}</h3>
                <FolderBtn isFolderOepn={isFolderOepn} isFolderOepnSet={setIsFolderOepn} ga360DataContents="아이템 정보" />
            </header>
            <article className={classNames({ 'is-active': isFolderOepn }, 'gameinfo-dict')}>
                <div className="gameinfo-loader">
                    <span className="loader" />
                </div>
                {iteminfo?.options && <OptionsList options={iteminfo?.options} />}
                {iteminfo?.subOptions?.fixes && <FixedOptions fixes={iteminfo?.subOptions?.fixes} />}
                {iteminfo?.subOptions?.randoms && (
                    <Randoms randoms={iteminfo?.subOptions?.randoms} isGemType={isGemItemType(iteminfo?.category2 as string)} />
                )}
                {iteminfo?.additional && <AdditionalEffects iteminfo={iteminfo} />}
                {iteminfo?.randomOptions && <RandomOptions iteminfo={iteminfo} />}
                {iteminfo?.description && <Description iteminfo={iteminfo} />}
                {iteminfo?.enchanted && <EnchantableItem enchanted={iteminfo?.enchanted} onClick={handleEnchantedClick} />}
            </article>

            <Tooltip disableStyleInjection={'core'} id={'my-tooltip_probability-button'} place="top">
                자세한 확률 정보는 게임 내<br className="small" />
                &nbsp;
                <strong style={{ fontWeight: 700 }}>‘아이템 &gt; 장비 관리’</strong>에서&nbsp;
                <br className="small" />
                확인하실 수 있습니다.
            </Tooltip>

            <Tooltip disableStyleInjection={'core'} id="my-tooltip_sub-ability" place="bottom">
                {iteminfo?.subOptions?.randoms && iteminfo?.subOptions?.randoms.length > 0 && (
                    <span className="sub-ability_con">
                        {iteminfo?.subOptions?.randoms[0].map((item, itemIndex) => (
                            <div key={`randoms-${itemIndex}`} className="sub-ability_item">
                                {item.name} {item.origin}
                            </div>
                        ))}
                    </span>
                )}
            </Tooltip>

            <Tooltip disableStyleInjection={'core'} id="my-tooltip_additional" place="bottom">
                {iteminfo?.additional?.options && iteminfo?.additional?.options?.length > 0 && (
                    <span className="sub-ability_con">
                        {iteminfo?.additional?.options?.map((item, itemIndex) => (
                            <div key={`randoms-${itemIndex}`} className="sub-ability_item">
                                {item.name} {item.origin}
                            </div>
                        ))}
                    </span>
                )}
            </Tooltip>
        </section>
    );
};
/* 
 openOnClick={true}
 */
